module.exports = __webpack_public_path__ + "img/agency-multiple-accounts.af1c543c.svg";